import { WorkspaceSettingsPages } from "@components/settings/constants";
import { useSettings } from "@components/settings/SettingsProvider";
import { useSideNavMode } from "@design-system/SideNav/SideNavProvider";
import { WorkspaceAction } from "@common/userWorkspaceRoles";
import { useCanPerformWorkspaceAction } from "@hooks/permissions/useCanPerformWorkspaceAction";
import { useOverlays } from "contexts/OverlayContext";
import { SideNavHelpMenu } from "./SideNavHelpMenu";
import { useInviteFirmMember } from "./useInviteFirmMember";
import { useOpenFirmSettings } from "./useOpenFirmSettings";

const WORKSPACE_MEMBERS_SETTINGS_PATH = WorkspaceSettingsPages.MEMBERS;

/** Workspace footer `?`: Add member invites to the workspace, Settings opens workspace Members. */
export const WorkspaceHelpMenu = () => {
    const { openOverlay } = useOverlays();
    const { validPaths, open: openSettings } = useSettings();
    const canAddMember = useCanPerformWorkspaceAction(
        WorkspaceAction.MEMBERS_EDIT,
    );
    const isMembersSettingsAvailable = validPaths.includes(
        WORKSPACE_MEMBERS_SETTINGS_PATH,
    );

    return (
        <SideNavHelpMenu
            onAddMember={
                canAddMember
                    ? () => openOverlay("memberManagementAddMember", {})
                    : undefined
            }
            onOpenSettings={() =>
                openSettings(
                    isMembersSettingsAvailable
                        ? [WORKSPACE_MEMBERS_SETTINGS_PATH]
                        : undefined,
                )
            }
        />
    );
};

/**
 * Org footer `?`: Settings opens firm Profile. Only a mini nav, whose footer
 * has no room for the Invite members button, lists Invite members here.
 */
export const OrgHelpMenu = () => {
    const inviteFirmMember = useInviteFirmMember();
    const openFirmSettings = useOpenFirmSettings();
    const isMini = useSideNavMode() === "mini";

    return (
        <SideNavHelpMenu
            addMemberLabel="Invite members"
            onAddMember={isMini ? inviteFirmMember : undefined}
            onOpenSettings={openFirmSettings}
        />
    );
};

/** Personal footer `?`: no member invite; Settings opens the user's own settings. */
export const PersonalHelpMenu = () => {
    const { open: openSettings } = useSettings();

    return <SideNavHelpMenu onOpenSettings={() => openSettings()} />;
};
